<template>
    <div id="data-list-list-view" class="data-list-container">
        <edit-type
                :isSidebarActive="showSidebar"
                :data="sidebarData"
                @closeSidebar="toggleSidebar"
                :edit="edit_state"
        />
        <vs-table
                ref="table"
                v-model="selected"
                :max-items="itemsPerPage"
                search
                :data="types"
        >
            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
                <div class="flex flex-wrap-reverse items-center data-list-btn-container">
                    <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
                    >
                        <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
                        <span class="ml-2 text-base text-primary" @click="addNewService">Nouveau type</span>
                    </div>
                </div>

            </div>

            <template slot="thead">
                <vs-th sort-key="name">Type</vs-th>
                <vs-th sort-key="category">Catégorie</vs-th>
                <vs-th sort-key="sla">Tps Priorité Très Elevée</vs-th>
                <vs-th sort-key="sla">Tps Priorité Elevée</vs-th>
                <vs-th sort-key="sla">Tps Priorité Moyenne </vs-th>
                <vs-th sort-key="sla">Tps Priorité basse </vs-th>
                <vs-th sort-key="has_approbationd">À approuver</vs-th>
                <vs-th sort-key="created_at">Créé le</vs-th>
                <vs-th>Action</vs-th>
            </template>

            <template slot-scope="{ data }">
                <tbody>
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.type }}</vs-td>
                    <vs-td>{{ tr.categories }}</vs-td>
                    <vs-td>{{ tr.sla_very_high }}min</vs-td>
                    <vs-td>{{ tr.sla_high + 'min' }}</vs-td>
                    <vs-td>{{ tr.sla_average + 'min' }}</vs-td>
                    <vs-td>{{ tr.sla_low + 'min' }}</vs-td>
                    <vs-td>
                        <vs-chip :color="tr.has_approbation ? 'primary' : 'danger'">{{ tr.has_approbation ? 'Oui' : 'Non' }}</vs-chip>
                    </vs-td>
                    <vs-td>{{ tr.created_at }}</vs-td>
                    <vs-td class="whitespace-no-wrap">
                        <div class="flex">
                            <vx-tooltip text="Détail">
                                <feather-icon
                                        icon="EyeIcon"
                                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                        class="mr-2"
                                        @click="detail(tr)"
                                />
                            </vx-tooltip>
                            <vx-tooltip text="Modifier">
                                <feather-icon
                                        icon="EditIcon"
                                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                        class="mr-2"
                                        @click="edit(tr)"
                                />
                            </vx-tooltip>
                            <vx-tooltip text="Supprimer">
                                <feather-icon
                                        icon="TrashIcon"
                                        svgClasses="w-5 h-5 hover:text-primary stroke-current"
                                        class="mr-2"
                                        @click="sub_requests_delete(tr.id)"
                                />
                            </vx-tooltip>
                        </div>
                    </vs-td>
                </vs-tr>
                </tbody>
            </template>
        </vs-table>
        <vs-pagination v-if="last_page && page" :total="last_page" v-model="page"></vs-pagination>
    </div>
</template>

<script>
    var base_self;
    import EditType from "./EditType";
    export default {
        components: {EditType},
        data() {
            return {
                edit_state: false,
                detail__detail: false,
                last_page: 1,
                page: 1,
                itemsPerPage: 8,
                isMounted: false,
                selected: [],
                sidebarData: {},
                showSidebar: false,
                types: []
            }
        },
        watch:{
            'page': function (val) {
                base_self.getSub_requests(val);
            }
        },
        computed: {
            currentPage() {
                if (this.isMounted) {
                    return this.$refs.table.currentx;
                }
                return 0;
            },

            queriedItems() {
                return this.$refs.table
                    ? this.$refs.table.queriedResults.length
                    : this.types.length;
            }
        },
        mounted() {
            this.isMounted = true;
            base_self.getSub_requests(base_self.page);
        },
        created() {
            base_self = this;
            window.TypesApp = this;
        },
        methods: {
            async getSub_requests (page) {
                this.$vs.loading()
                let response = await base_self.$store.state.sub_requests({}, { page });
                base_self.last_page = response.data.last_page;
                base_self.types = response.data.data;
                this.$vs.loading.close()
            },
            toggleSidebar(val = false) {
                this.showSidebar = val;
            },
            addNewService(){
                this.sidebarData = {};
                this.toggleSidebar(true);
            },
            detail(data){
                this.sidebarData = data;
                this.detail__detail = true;
                this.toggleSidebar(true);
            },
            edit(data){
                this.edit_state = true
                this.sidebarData = data;
                this.detail__detail = false;
                this.toggleSidebar(true);
            },
            async sub_requests_delete(id) {
                this.$vs.dialog({
                    type:'confirm',
                    color: 'danger',
                    title: 'Confirmation',
                    text: 'Confirmer la suppression?',
                    acceptText: 'Confirmer',
                    cancelText: 'Annuler',
                    accept: async () => {
                        base_self.$vs.loading()
                        let response = await base_self.$store.state.sub_requests_delete({ id });

                        if (response.data.status) {
                          base_self.$vs.loading.close()
                            window.GETCCMT.success('Le type de demande est supprimée avec succès.', response);
                        } else {
                          base_self.$vs.loading.close()
                            window.GETCCMT.error({ message: 'La suppression du type de demande a échouée.' });
                        }
                        base_self.getSub_requests(base_self.page);
                    }
                })
            },
        }
    }
</script>

<style lang="scss">
    #data-list-list-view {
        .vs-con-table {
            @media (max-width: 689px) {
                .vs-table--search {
                    margin-left: 0;
                    max-width: unset;
                    width: 100%;

                    .vs-table--search-input {
                        width: 100%;
                    }
                }
            }

            @media (max-width: 461px) {
                .items-per-page-handler {
                    display: none;
                }
            }

            @media (max-width: 341px) {
                .data-list-btn-container {
                    width: 100%;

                    .dd-actions,
                    .btn-add-new {
                        width: 100%;
                        margin-right: 0 !important;
                    }
                }
            }

            .product-name {
                max-width: 23rem;
            }

            .vs-table--header {
                display: flex;
                flex-wrap: wrap;
                margin-left: 1.5rem;
                margin-right: 1.5rem;
                > span {
                    display: flex;
                    flex-grow: 1;
                }

                .vs-table--search {
                    padding-top: 0;

                    .vs-table--search-input {
                        padding: 0.9rem 2.5rem;
                        font-size: 1rem;

                        & + i {
                            left: 1rem;
                        }

                        &:focus + i {
                            left: 1rem;
                        }
                    }
                }
            }

            .vs-table {
                border-collapse: separate;
                border-spacing: 0 0.5rem;
                padding: 0 1rem;

                tr {
                    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
                    td {
                        padding: 20px;
                        &:first-child {
                            border-top-left-radius: 0.5rem;
                            border-bottom-left-radius: 0.5rem;
                        }
                        &:last-child {
                            border-top-right-radius: 0.5rem;
                            border-bottom-right-radius: 0.5rem;
                        }
                    }
                    td.td-check {
                        padding: 20px !important;
                    }
                }
            }

            .vs-table--thead {
                th {
                    padding-top: 0;
                    padding-bottom: 0;

                    .vs-table-text {
                        text-transform: uppercase;
                        font-weight: 600;
                    }
                }
                th.td-check {
                    padding: 0 15px !important;
                }
                tr {
                    background: none;
                    box-shadow: none;
                }
            }

            .vs-table--pagination {
                justify-content: center;
            }
        }
    }
</style>
